export const buildSimpleTextFilter = (text) => {
    if (!text)
        return undefined;
    return { in: [text] };
};
